import AutoplayModel from "slotworks/model/autoplay-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import CancelAutoButtonBehaviour from "slotworks/smart-button/behaviours/cancel-auto-button-behaviour";
import DisabledSpinButtonBehaviour from "slotworks/smart-button/behaviours/disabled-spin-button-behaviour";
import FreespinButtonBehaviour from "slotworks/smart-button/behaviours/freespin-button-behaviour";
import SelectAutoButtonBehaviour from "slotworks/smart-button/behaviours/select-auto-button-behaviour";
import SkipButtonBehaviour from "slotworks/smart-button/behaviours/skip-button-behaviour";
import SpinButtonBehaviour from "slotworks/smart-button/behaviours/spin-button-behaviour";
import { addRepeated } from "slotworks/utils/collection-utils";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import NoSkipButtonBehaviour from "slotworks/smart-button/behaviours/no-skip-button-behaviour";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

class SmartButton {

    private behaviourMap: ButtonBehaviour[] = [];

    private bitmask: number = 1;

    private currentBehaviour: AbstractButtonBehaviour;

    constructor() {
        AutoplayModel.onDecrease.add(() => {
            if (!AutoplayModel.isAutoPlaying() && !CampaignsModel.isFreespinsActive()) {
                this.setFlag(SmartButtonFlag.AUTO_SPIN, false);
            }
        });

        this.behaviourMap.push(SkipButtonBehaviour); // 0
        this.behaviourMap.push(SpinButtonBehaviour); // 1
        addRepeated(this.behaviourMap, SelectAutoButtonBehaviour, 2); // 2, 3
        addRepeated(this.behaviourMap, DisabledSpinButtonBehaviour, 2); // 4, 5
        addRepeated(this.behaviourMap, null, 2); // 6, 7
        addRepeated(this.behaviourMap, FreespinButtonBehaviour, 8); // 8-15
        // TODO maybe replace this with waiting
        addRepeated(this.behaviourMap, DisabledSpinButtonBehaviour, 16); // 16-31
        addRepeated(this.behaviourMap, DisabledSpinButtonBehaviour, 32); // 32-63
        // TODO maybe replace with replay button
        addRepeated(this.behaviourMap, CancelAutoButtonBehaviour, 64); // 64-127
        addRepeated(this.behaviourMap, DisabledSpinButtonBehaviour, 128); // 128-255
        addRepeated(this.behaviourMap, DisabledSpinButtonBehaviour, 256); // 256-511
    }

    public overrideBehaviour(mask: number, behaviour: ButtonBehaviour) {
        this.behaviourMap[mask] = behaviour;
    }

    public init() {
        if(SettingsModel.isSkipDisabled()) { // no skip functionality
            this.behaviourMap[0] = NoSkipButtonBehaviour;
        }
        this.updateBehaviour();
    }

    public setFlag(flag: SmartButtonFlag, value: boolean) {
        if (value) {
            this.bitmask |= flag;
        } else {
            this.bitmask &= ~flag;
        }
        if(flag === 32 && !AutoplayModel.isAutoPlaying()) this.bitmask = 0;

        this.updateBehaviour();
    }

    public hasFlag(flag: SmartButtonFlag) {
        return (this.bitmask & flag) !== 0;
    }

    public refresh() {
        this.updateBehaviour();
    }

    private updateBehaviour() {
        if (this.behaviourMap.length <= this.bitmask) {
            throw new Error("Invalid state bitmask on smart button");
        }
        const currentGame = gameState.getCurrentGame();
        const currentRecord:any = currentGame.getCurrentRecord();
        const isCurrentRecordSpin = currentRecord instanceof FreespinRecord;

        if(isCurrentRecordSpin && currentRecord.remainingFreespins != 0) this.bitmask = 8;

        const newBehaviour = this.behaviourMap[this.bitmask];

        if (this.currentBehaviour) {
            this.currentBehaviour.destroy();
        }

        this.currentBehaviour = new newBehaviour();
        this.currentBehaviour.init();
    }

}

export default new SmartButton();

export enum SmartButtonFlag {
    IDLE = 1,
    AUTO_SPIN_SELECT = 2,
    SKIP_COOLDOWN = 4,
    FREE_SPINS = 8,
    BONUS = 16,
    AWAITING_RESPONSE = 32,
    AUTO_SPIN = 64,
    REPLAY = 128,
    PROMPT = 256,
    MAX = 512
}

interface ButtonBehaviour {
    new(): AbstractButtonBehaviour;
}



// WEBPACK FOOTER //
// ./~/slotworks/smart-button/smart-button.ts